export { PaymentIcons } from './PaymentIcons'
